/** Public runtime config baked in at build time from .env (VITE_*). */
export const config = {
  apiUrl: import.meta.env.VITE_API_URL ?? "",
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? "",
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID ?? "",
  },
};
